import styled, { css } from 'styled-components';
import { down } from 'styled-breakpoints';
import { motion } from 'framer-motion';

import { PerfectScrollbar } from '@components';

export const Container = styled(motion.dialog)`
  ${({ theme }) => css`
    padding: 2.5rem 2rem;
    margin: auto;
    width: 100%;
    max-width: 60rem;
    height: 100%;
    max-height: 90%;
    border-radius: 1rem;
    position: relative;
    background: ${theme.colors.background[100]};
    color: ${theme.colors.foreground[100]};

    box-shadow: 0px 2.8px 2.2px rgba(0, 0, 0, 0.02),
      0px 6.7px 5.3px rgba(0, 0, 0, 0.028), 0px 12.5px 10px rgba(0, 0, 0, 0.035),
      0px 22.3px 17.9px rgba(0, 0, 0, 0.042),
      0px 41.8px 33.4px rgba(0, 0, 0, 0.05), 0px 100px 80px rgba(0, 0, 0, 0.07);

    > h2 {
      padding-bottom: 0.5rem;
      border-bottom: 2px solid ${theme.colors.background[80]};
    }

    ${down('md')} {
      padding: 2.5rem 1.25rem;
    }
  `}
`;

export const RulesWrapper = styled(PerfectScrollbar)`
  ${() => css`
    padding-top: 1rem;
    height: 100%;
    max-height: calc(100% - 2.5rem);

    p {
      margin: 1rem 0;
    }

    img {
      display: block;
      margin: 0 auto;
      max-width: 100%;
      height: auto;
    }
  `}
`;
